'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _universalCookie = require('universal-cookie');

var _universalCookie2 = _interopRequireDefault(_universalCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _universalCookie2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-cookie/lib/Cookies.js
// module id = 461
// module chunks = 114276838955818